<template>
  <v-dialog v-model="dialog" persistent fullscreen>
    <v-card>
      <v-card-title class="mx-5 pt-5">
        <v-row>
          <v-spacer></v-spacer>
          <v-btn icon color="#00A99D" @click="closeDialog()" :loading="loadingClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>

      <v-row class="my-3 mx-10 bg-EDF8F7">
        <v-col cols="12" class="px-8'">
          <Header :general_info="item" />
        </v-col>
      </v-row>

      <v-card-text v-if="from !== 'detail'" class="pb-5">
        <v-form ref="info_vali">
          <v-col cols="12" class="py-0">
            <v-tabs color="#00A99D" class="elevation-0" v-model="tabsItem" show-arrows grow center-active>
              <v-tabs-slider color="#00A99D"></v-tabs-slider>
              <v-tab class="tab pb-2" v-for="(item, index) in tab" :key="index" color="#00A99D">
                <v-chip color="#ceefed78" dark v-if="tabsItem == index">
                  <img :src="item.image" />
                </v-chip>
                <v-chip color="#fff" dark v-else>
                  <img :src="item.image" />
                </v-chip>
                <span class="font-16 px-2"> {{ item.title }} </span>

              </v-tab></v-tabs>

            <v-tabs-items v-model="tabsItem">
              <!-- ------------------------*** 0 ****------------------------------ -->
              <v-tab-item eager>
                <Map ref="map" @data1="getData1" @valid1="getValid1" :status="this.from" />
              </v-tab-item>
              <!-- ------------------------*** 1 ****------------------------------ -->
              <v-tab-item eager>
                <Record ref="record" @data2="getData2" @valid2="getValid2" :status="this.from"
                  :data3="this.data_4 ? this.data_4 : ''" />
              </v-tab-item>

              <!-- ------------------------*** 2 ****------------------------------ -->
              <v-tab-item eager>
                <Estimation ref="estimation" @data3="getData3" @valid3="getValid3" :status="this.from"
                  :data3="this.data_4 ? this.data_4 : ''" :appointment="this.appointment" />
              </v-tab-item>

              <!-- ------------------------*** 3 ****------------------------------ -->
              <v-tab-item eager>
                <followUp ref="followup" @data4="getData4" @dataFiles4="getDataFiles4" @valid4="getValid4"
                  :status="this.from" :data1="this.data_2 ? this.data_2 : ''" :data2="this.data_3 ? this.data_3 : ''"
                  :appointment="this.appointment" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-form>
      </v-card-text>
      <v-card-text v-else-if="from == 'detail'" class="pb-5">
        <v-col cols="12" class="py-0">
          <DetailDialog :item="item" :value="value" />
        </v-col>
      </v-card-text>

      <!-- <v-card-actions> -->
      <v-footer inset color="#FFFFFF" class="pt-2">
        <v-row v-if="from !== 'see' && from !== 'detail'">
          <v-col cols="12" lg="4" md="4" sm="4" align="center">
            <v-btn depressed outlined color="#00A99D" rounded @click="back_step()" width="60%"
              style="border-radius: 20px 5px;" v-if="tabsItem !== 0">
              <span class="text-00A99D">ย้อนกลับ</span>
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="4" align="center">
            <v-btn width="60%" depressed color="#00A99D" style="border-radius: 20px 5px;" dark rounded
              :loading="loadingDraft" @click="confirm('draft')">
              <span class="text-white">บันทึกฉบับร่าง</span>
            </v-btn>
          </v-col>
          <v-col v-if="tabsItem == 3" cols="12" lg="4" md="4" sm="4" align="center">
            <!-- <v-col cols="12" lg="4" md="4" sm="4" align="center" v-if="val == true && val !== null"></v-col> -->
            <v-btn width="60%" depressed color="#00A99D" style="border-radius: 20px 5px;" dark rounded
              :loading="loadingFinish" @click="confirm('finish')">
              <span class="text-white">บันทึก</span>
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="4" align="center">
            <v-btn width="60%" depressed outlined color="#00A99D" rounded @click="next_step()"
              style="border-radius: 20px 5px;" v-if="tabsItem !== 3">
              <span class="text-00A99D">ถัดไป</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else-if="from == 'detail'" justify="center" class="mb-5">
          <v-btn width="15%" style="border-radius: 20px 5px;" depressed outlined color="#00A99D" dark rounded
            @click="closeDialog()" :loading="loadingClose">
            <span>ปิด</span>
          </v-btn>
        </v-row>
      </v-footer>
      <!-- </v-card-actions> -->
    </v-card>

    <v-dialog v-model="loadingFinish" persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1 card-style">
        <v-card-text class="text-center">
          <!-- กำลังดาวน์โหลดเอกสาร -->
          กำลังบันทึกข้อมูล
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import Header from "./ComponentHomeVisit/Header_Homevisit.vue";
import Map from "../HomeVisit/ComponentHomeVisit/Map_HomeVisit.vue";
import Record from "../HomeVisit/ComponentHomeVisit/Record_HomeVisit.vue";
import Estimation from "../HomeVisit/ComponentHomeVisit/Estimation_HomeVisit.vue";
import FollowUp from "../HomeVisit/ComponentHomeVisit/FollowUp_Homevisit.vue";
import DetailDialog from "../HomeVisit/DetailDialog.vue";


export default {
  components: {
    Header,
    Map,
    Record,
    Estimation,
    FollowUp,
    DetailDialog,
  },
  data() {
    return {
      dialog: false,
      tabsItem: 0,
      tab: [
        {
          title: "แผนที่แสดงบ้านของผู้รับบริการ",
          image: require('@/assets/image/homevisit_01.svg'),
        },
        {
          title: "แบบบันทึกการเยี่ยมบ้านรายบุคคล",
          image: require('@/assets/image/homevisit_02.svg'),
        },
        {
          title: "ประเมินสภาพผู้ป่วย INHOMESSS",
          image: require('@/assets/image/homevisit_03.svg'),
        },
        {
          title: "แบบบันทึกและติดตามการเยี่ยมบ้าน",
          image: require('@/assets/image/homevisit_04.svg'),
        },
      ],
      nav: null,
      url: null,
      val: null,
      from: '',
      data_1: {},
      data_2: {},
      data_3: {},
      data_4: {},
      data_files4: [],
      all_data: {},
      valid_1: false,
      valid_2: false,
      valid_3: false,
      valid_4: false,
      item: {},
      value: {},
      loadingDraft: false,
      loadingFinish: false,
      taxid: '',
      folder_id: '',
      onebox_account_id: '',
      tabs: [],
      loadingClose: false,
      appointment: false
    };
  },
  watch: {
    async tabsItem(val) {
      this.tabs.push(val)
      // console.log("val", val);
      // console.log('this.tabs', this.tabs);

      if (val == 0) {
        this.$refs.map.get_img('draft')
      }

      if (val == 3) {
        if (this.appointment == false) {
          await this.$refs.map.valid1()
          await this.$refs.record.valid2()
          await this.$refs.estimation.valid3()
          await this.$refs.followup.valid4()

          if (this.valid_1 == true && this.valid_2 == true && this.valid_3 == true && this.valid_4 == true) {
            this.val = true
          }
        }
      }
      else if (val != 3) {
        var before_index = this.tabs.length - 2

        if (this.tabs[before_index] == 3) {
          await this.$refs.map.valid1()
          await this.$refs.followup.valid4()
          await this.$refs.record.valid2()
          await this.$refs.estimation.valid3()
        } else if (this.tabs[before_index] != 3) {
          await this.$refs.map.valid1()
          await this.$refs.record.valid2()
          await this.$refs.estimation.valid3()
          await this.$refs.followup.valid4()
        }

        if (this.valid_1 == true && this.valid_2 == true && this.valid_3 == true && this.valid_4 == true) {
          this.val = true
        }
      }
    },
  },
  computed: {
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      },
    },
    phone() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    getDataFiles4(x) {
      // console.log("getDataFiles4", x);
      this.data_files4 = x
    },
    getValid4(y) {
      this.valid_4 = y
    },
    getData4(x) {
      this.data_4 = x
    },
    getValid3(y) {
      this.valid_3 = y
    },
    getData3(x) {
      this.data_3 = x
    },
    getValid2(y) {
      this.valid_2 = y
    },
    getData2(x) {
      this.data_2 = x
    },
    getValid1(y) {
      this.valid_1 = y
    },
    getData1(x) {
      this.data_1 = x
    },
    async openDialog(item, value, text) {
      console.log('openDialog', item);
      // console.log('item' , item);
      // console.log('value', value);
      // console.log('text', text);
      this.from = text
      this.item = item
      this.value = value
      this.dialog = true;

      if (text !== 'see') {
        await this.getDataFrom(item)
        await this.getFlie(value)
        await this.getOrganizationAction()
      }
    },
    closeDialog() {
      if (this.from != 'detail' && this.from != 'see' && this.from != undefined) {
        // this.loadingClose = true
        // setTimeout(async () => {
        //   this.appointment = false
        //   this.val = false
        //   this.from = ''
        //   this.data_1 = {}
        //   this.data_2 = {}
        //   this.data_3 = {}
        //   this.data_4 = {}
        //   this.data_files4 = []
        //   this.all_data = {}
        //   this.valid_1 = null
        //   this.valid_2 = null
        //   this.valid_3 = null
        //   this.valid_4 = null
        //   this.item = {}
        //   this.value = {}
        //   this.getData = {}
        //   this.tabs = []
        //   this.loadingClose = false
        //   this.dialog = false
        // }, 2000)
        this.appointment = false
        this.val = false
        this.from = ''
        this.data_1 = {}
        this.data_2 = {}
        this.data_3 = {}
        this.data_4 = {}
        this.data_files4 = []
        this.all_data = {}
        this.valid_1 = null
        this.valid_2 = null
        this.valid_3 = null
        this.valid_4 = null
        this.item = {}
        this.value = {}
        this.getData = {}
        this.tabs = []
        this.dialog = false
      } else {
        this.appointment = false
        this.val = false
        this.from = ''
        this.data_1 = {}
        this.data_2 = {}
        this.data_3 = {}
        this.data_4 = {}
        this.data_files4 = []
        this.all_data = {}
        this.valid_1 = null
        this.valid_2 = null
        this.valid_3 = null
        this.valid_4 = null
        this.item = {}
        this.value = {}
        this.getData = {}
        this.tabs = []
        this.dialog = false
      }
    },
    set_data() {
      this.val = this.$refs.info_vali.validate();
      // console.log(this.val)
    },
    back_step() {
      if (this.tabsItem !== 0) {
        this.tabsItem = this.tabsItem - 1;
      }

      // console.log("back_step", this.tabsItem);
    },
    async next_step() {
      if (this.tabsItem === 0) {
        await this.$refs.map.valid1('1page')
        if (this.valid_1) {
          this.$swal({
            title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
            icon: "error",
            showCloseButton: false,
            showConfirmButton: false,
            background: "white",
            timer: 3000,
          });
          return;
        } else {
          await this.$refs.map.get_img();
        }
      } else if (this.tabsItem === 1) {
        await this.$refs.record.valid2('2page')
        if (this.valid_2) {
          this.$swal({
            title:
              "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
            icon: "error",
            showCloseButton: false,
            showConfirmButton: false,
            background: "white",
            timer: 3000,
          });
          return;
        }
      } else if (this.tabsItem === 2) {
        await this.$refs.estimation.valid3('3page')
        if (this.valid_3) {
          this.$swal({
            title:
              "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
            icon: "error",
            showCloseButton: false,
            showConfirmButton: false,
            background: "white",
            timer: 3000,
          });
          return;
        }
      } 
      if (this.tabsItem !== 3) {
        this.tabsItem = this.tabsItem + 1;
      }
    },
    async getOrganizationAction() {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.getItem("biz_id"));
        await this.axios
          .get(
            process.env.VUE_APP_BACKEND_URL + `/v1/organization/getOrganizationByBizId?${params}`
          )
          .then((res) => {
            // console.log('res' ,res);
            if (res.data.result == "success") {
              this.taxid = res.data.data.taxid
            }
          });
      } catch (error) {
        console.log("error", error);
      }
    },
    async StepOneFiles(status) {
      if (this.tabsItem == 0) {
        await this.$refs.map.get_img(status)
      }
      // await this.$refs.map.valid1(status)
      // await this.$refs.record.valid2(status)
      // await this.$refs.estimation.valid3(status)
      // await this.$refs.followup.valid4(status)

      // console.log("this.valid_1", this.valid_1)
      // console.log("this.valid_2", this.valid_2)
      // console.log("this.valid_3", this.valid_3)
      // console.log("this.valid_4", this.valid_4)

      var body = {
        oneid: sessionStorage.getItem("oneId"),
        taxid: this.taxid
      }
      // console.log("body", body)
      await
        this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/home_visit/check_permission_Onebox`, body,
        ).then(async (response) => {
          // console.log('response', response);
          if (response.data.result === "success") {
            this.folder_id = response.data.data.folder_id
            this.onebox_account_id = response.data.data.onebox_account_id
            await this.StepTwoFiles(status);
          } else {
            this.$swal.fire("ผิดพลาด");
            this.loadingDraft = false
            this.loadingFinish = false
          }
        }).catch((err) => {
          this.$swal.fire("ผิดพลาด");
          this.loadingDraft = false
          this.loadingFinish = false
          console.log(err);
        });
    },
    async StepTwoFiles(status) {
      let form_data = new FormData();
      // console.log("StepTwoFiles", this.data_files4);
      if (this.data_files4.length != 0) {
        for (let index = 0; index < this.data_files4.length; index++) {
          form_data.append("files", this.data_files4[index]);
        }
      }

      // let config = {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // };
      let params = new URLSearchParams()
      params.append("template_id", this.value.template_id)
      params.append("taxid", this.taxid)
      params.append("onebox_account_id", this.onebox_account_id)
      params.append("folder_id", this.folder_id)

      let config = {
        method: 'post',
        url: `${process.env.VUE_APP_BACKEND_URL}/v1/home_visit/insertFile?${params}`,
        data: form_data,
        headers: { "Content-Type": "multipart/form-data" },
      };

      await this.axios(config).then(async (response) => {
        // console.log('response', response);
        if (response.data.result === "success") {
          this.saveFrom(status)
        } else {
          this.$swal.fire("ผิดพลาด");
          this.loadingDraft = false
          this.loadingFinish = false
        }
      }).catch((err) => {
        this.$swal.fire("ผิดพลาด");
        this.loadingDraft = false
        this.loadingFinish = false
        console.log(err);
      });
    },
    async getDataFrom(item) {
      console.log('this.value', this.value.template_id);
      try {
        var params = new URLSearchParams()
        params.append('template_id', this.value.template_id)
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('userqr_id', item.userqr_id || '')

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_home_visits_byid?${params}`,
        ).then(async (res) => {
          console.log('res get from', res);
          if (res.data.result === "success" && res.data.code === 200) {
            if (res.data.message == "have save appointment no.1") {
              this.tabsItem = 3
              this.appointment = true
            } else {
              this.tabsItem = 0
              this.appointment = false
            }

            if ('map_detail' in res.data.data && 'family_detail' in res.data.data && res.data.data.map_detail !== null && res.data.data.map_detail !== undefined && res.data.data.family_detail !== null && res.data.data.family_detail !== undefined && this.from == 'register') {
              await this.$refs.map.openPage(res.data.data.map_detail, res.data.data.family_detail)
            }

            if ('individual_home_visits' in res.data.data && res.data.data.individual_home_visits !== null && res.data.data.individual_home_visits !== undefined && this.from == 'register') {
              await this.$refs.record.openPage(item, res.data.data.individual_home_visits)
            } else if (this.from == 'register') {
              await this.$refs.record.openPage(item, null)
            }

            if ('inhomesss' in res.data.data && res.data.data.inhomesss !== null && res.data.data.inhomesss !== undefined && this.from == 'register') {
              await this.$refs.estimation.openPage(res.data.data.inhomesss)
            }

            if ('home_visit_recording' in res.data.data && res.data.data.home_visit_recording !== null && res.data.data.home_visit_recording !== undefined && this.from == 'register') {
              await this.$refs.followup.openPage(item, res.data.data.home_visit_recording)
            } else if (this.from == 'register') {
              await this.$refs.followup.openPage(item, null)
            }

          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>การดึงข้อมูลผิดพลาด</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }
        })
      } catch (error) {
        console.log('error', error);
      }
    },
    async getFlie(value) {
      try {
        var params = new URLSearchParams()
        params.append('template_id', value.template_id)
        params.append('biz_id', sessionStorage.getItem('biz_id'))

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_file?${params}`,
        ).then((res) => {
          // console.log('res getFlie', res);
          if (res.data.result === "success" && res.data.code === 200) {
            if ('files' in res.data.data && res.data.data.files !== null && res.data.data.files !== undefined && res.data.data.files.length !== 0 && this.from == 'register') {
              this.$refs.followup.openFiles(res.data.data)
            }
          }
        })
      } catch (error) {
        console.log('error', error);
      }
    },
    async confirm(status) {
      if (status == 'draft') {
        this.loadingDraft = true
        this.StepOneFiles('draft')
        // this.saveFrom('draft')
      } else if (status == 'finish') {
        await this.$refs.map.valid1(status)
        await this.$refs.record.valid2(status)
        await this.$refs.estimation.valid3(status)
        await this.$refs.followup.valid4(status)
        if (this.valid_1 || this.valid_2 || this.valid_3 || this.valid_4) {
          this.$swal({
            title:
              "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบ</span>",
            icon: "error",
            showCloseButton: false,
            showConfirmButton: false,
            background: "white",
            timer: 3000,
          });
        } else {
          this.$swal.fire({
            title:
              "<span style='color: black;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการบันทึกแบบฟอร์มใช่หรือไม่ ?</span>",
            icon: "question",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonText:
              "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
            cancelButtonColor: "#FFFFFF",
            showConfirmButton: true,
            confirmButtonText:
              "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
            confirmButtonColor: "#00A99D",
            allowOutsideClick: false,
          })
            .then((result) => {
              if (result.isConfirmed) {
                this.loadingFinish = true
                this.StepOneFiles('finish')
                // this.saveFrom('finish')
              }
            });
        }
      }
    },
    async saveFrom(status) {

      // if(this.tabsItem == 0) {
      //   await this.$refs.map.get_img()
      // }
      // await this.$refs.map.valid1()
      // await this.$refs.record.valid2()
      // await this.$refs.estimation.valid3()
      // await this.$refs.followup.valid4()


      // set from data 1
      this.all_data.map_detail = this.data_1.map_detail
      this.all_data.family_detail = {
        family_image: this.data_1.family_image,
        family_member: this.data_1.family_member,
        family_list: this.data_1.family_list,
        family_problem: this.data_1.family_problem
      }

      // set from data 2 & 3
      this.all_data.individual_home_visits = {
        clinic_name: this.data_2.clinic_name,
        authentication_code: this.data_2.Authentication_code,
        general_info: this.data_2.general_info,
      }

      //set from data 3
      this.all_data.inhomesss = this.data_3

      // set from data 4
      this.all_data.home_visit_recording = this.data_4

      this.all_data.actions_type = status

      // console.log('this.all_data', this.all_data);
      // console.log('status', status);

      // console.log('this.data_files4', this.data_files4);

      try {

        var params = new URLSearchParams()
        params.append('template_id', this.value.template_id)
        params.append('appointment_id', this.item.appointment_id)
        params.append('account_id', sessionStorage.getItem("account_id"))
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('actions_type', status)

        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/update_template_home_visit?${params}`, this.all_data,
        ).then((res) => {
          // console.log('res save from', res);
          if (res.data.result === "success" && res.data.code === 200) {
            this.$swal({
              title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
              icon: "success",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#00A99D",
              timer: 2000,
            }).then(() => {
              this.loadingDraft = false
              this.loadingFinish = false
              this.dialog = false
              this.$emit("close")
              this.$emit("status_type", status)
            })
          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            }).then(() => {
              this.loadingDraft = false
              this.loadingFinish = false
            })
          }
        })
      } catch (error) {
        console.log('error', error);
        this.$swal.fire("ผิดพลาด");
        this.loadingDraft = false
        this.loadingFinish = false
      }
    },
  },
};
</script>

<style scoped>
.text_name {
  text-align: end;
  padding-bottom: 0px;
  padding-left: 10px;
  justify-self: center;
  align-self: center;
}

.text_Body {
  align-self: center;
  padding-top: 0px;
  padding-bottom: 0px;
  justify-content: center;
}

.text_body {
  align-self: center;
  padding-bottom: 0px;
  justify-content: center;
}

.card-border-title {
  border-right: 2px solid #00A99D;
}

.card-border-title-phone {
  border-bottom: 2px solid #00A99D;
}

.card-border {
  border-top: 2px solid #00A99D;
  border-left: 2px solid #00A99D;
  border-right: 2px solid #00A99D;
}

.card-border-end {
  border-bottom: 2px solid #00A99D;
}

.card-none-shadow {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-input--selection-controls__input+.v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: #00A99D !important;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-input--selection-controls__input+.v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #313b41;
}

::v-deep .v-input--is-disabled>.v-input__control>.v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog>.v-card>.v-card__text {
  padding: 0px;
}

::v-deep > .v-dialog>.card-style>.v-card__text {
  padding: 0 24px 20px;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

::v-deep .v-text-field.v-text-field--solo.v-input--dense .v-input__append-outer {
  margin-top: 0px !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #313b41 !important;
}

.gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
}

.gmap-auto:focus {
  outline: none !important;
}

::v-deep .v-select__selections {
  line-height: 1.8rem;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control input {
  line-height: 1.8rem;
}

::v-deep .v-input input {
  line-height: 1.8rem;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>